<div class="row page-title">
  <span>{{
    localizationConstants.LOCALIZATION_EDIT_PAGE_TITLE | translate: { value: language }
  }}</span>
</div>

<div class="row">
  <div class="c-details col">
    <div
      *ngIf="isDefaultLanguage"
      class="c-details__action-button u-mt--large">
      <button
        (click)="openAddTranslationModal()"
        type="button"
        class="button button-primary button-block u-mobile">
        {{ localizationConstants.LOCALIZATION_ADD | translate }}
      </button>
      <button
        (click)="openAddTranslationModal()"
        type="button"
        class="button--sm button-primary u-tablet">
        {{ localizationConstants.LOCALIZATION_ADD | translate }}
      </button>
    </div>
  </div>
</div>

<div
  [hidden]="!dataSource.data"
  class="row">
  <div class="col">
    <div class="col-12 col-sm-6 col-md-3 u-mb--medium">
      <form class="c-search-form--full">
        <div class="c-input-group">
          <input
            type="text"
            name="search"
            id="input-search"
            [(ngModel)]="dataSource.filter"
            class="c-input c-input--beta"
            placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
            required />
          <input
            *ngIf="dataSource.filter"
            id="languages-edit-search-clear"
            (click)="dataSource.filter = ''"
            class="c-button c-button--search c-close-search c-button--search--sm"
            value="Clear" />
          <input
            *ngIf="!dataSource.filter"
            id="languages-edit-search"
            type="submit"
            class="c-button c-button--search c-button--search--sm"
            value="Search" />
        </div>
      </form>
    </div>
    <div class="u-scroll--horizontal">
      <div class="col">
        <table
          mat-table
          matSort
          [dataSource]="dataSource"
          class="c-table">
          <ng-container matColumnDef="key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="c-table__column-title"
              width="5%">
              {{
                (isDefaultLanguage
                  ? localizationConstants.LOCALIZATION_KEY
                  : localizationConstants.LOCALIZATION_GROUP
                ) | translate
              }}
            </th>
            <td
              mat-cell
              *matCellDef="let translation">
              {{
                isDefaultLanguage
                  ? translation.key
                  : (translation.key | firstFromSplit: "." | titlecase)
              }}
            </td>
          </ng-container>

          <ng-container matColumnDef="englishValue">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="c-table__column-title"
              width="35%">
              {{ localizationConstants.LOCALIZATION_ENGLISH_PHRASE | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let translation">
              {{ translation.englishValue }}
            </td>
          </ng-container>

          <ng-container matColumnDef="translatedValue">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="c-table__column-title"
              width="40%">
              {{ localizationConstants.LOCALIZATION_TRANSLATED_PHRASE | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let translation">
              <span *ngIf="translation.translatedValue && !translation.isEditing">{{
                translation.translatedValue
              }}</span>
              <span>
                <input
                  *ngIf="!translation.translatedValue && !translation.isEditing"
                  [(ngModel)]="translation.newValue"
                  name="newValue"
                  type="text"
                  placeholder="{{ localizationConstants.LOCALIZATION_ADD_PLACEHOLDER | translate }}"
                  class="c-input c-input--gamma"
                  [disabled]="translation.isItemLoading"
                  required />
              </span>
              <span>
                <input
                  *ngIf="translation.isEditing"
                  [ngModel]="translation.translatedValue"
                  id="translatedValue"
                  name="translatedValue"
                  #translatedValue
                  (ngModelChange)="translation.newValue = translatedValue.value"
                  type="text"
                  class="c-input c-input--gamma"
                  [disabled]="translation.isItemLoading"
                  required />
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="action1">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="c-table__column-title"
              width="10%"></th>
            <td
              mat-cell
              *matCellDef="let translation">
              <button
                *ngIf="translation.translatedValue && !translation.isEditing"
                type="button"
                class="button--sm button-secondary button-block"
                (click)="translation.isEditing = !translation.isEditing">
                <span>{{ localizationConstants.BUTTON_EDIT | translate }}</span>
              </button>
              <button
                *ngIf="translation.translatedValue && translation.isEditing"
                type="button"
                class="button--sm button-primary button-block"
                (click)="updateLocalization(translation)"
                [disabled]="translation.isItemLoading || !translation.newValue">
                <app-loading-icon *ngIf="translation.isItemLoading"></app-loading-icon>
                <span *ngIf="!translation.isItemLoading">{{
                  localizationConstants.BUTTON_SAVE | translate
                }}</span>
              </button>
              <button
                *ngIf="!translation.translatedValue"
                type="button"
                class="button--sm button-primary button-block"
                (click)="addLocalization(translation)"
                [disabled]="translation.isItemLoading">
                <app-loading-icon *ngIf="translation.isItemLoading"></app-loading-icon>
                <span *ngIf="!translation.isItemLoading">{{
                  localizationConstants.BUTTON_ADD | translate
                }}</span>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="action2">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="c-table__column-title"
              width="10%"></th>
            <td
              mat-cell
              *matCellDef="let translation">
              <button
                *ngIf="translation.translatedValue && !translation.isEditing"
                type="button"
                class="button--sm button-secondary button-block"
                (click)="onDeleteLocalization(translation)"
                [disabled]="!authService.user?.isAdmin && isDefaultLanguage">
                <span>{{ localizationConstants.BUTTON_DELETE | translate }}</span>
              </button>
              <button
                *ngIf="!translation.translatedValue && !translation.isEditing"
                type="button"
                class="button--sm button-secondary button-block"
                (click)="translation.newValue = null">
                <span>{{ localizationConstants.BUTTON_CLEAN | translate }}</span>
              </button>
              <button
                *ngIf="translation.translatedValue && translation.isEditing"
                type="button"
                class="button--sm button-secondary button-block"
                (click)="translation.isEditing = !translation.isEditing"
                [disabled]="translation.isItemLoading">
                <span>{{ localizationConstants.BUTTON_CANCEL | translate }}</span>
              </button>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="columnsToDisplay"></tr>
          <tr
            mat-row
            *matRowDef="let translation; columns: columnsToDisplay"
            class="c-table__row"></tr>
        </table>
      </div>
    </div>
    <div class="c-pagination--desktop">
      <div class="col-12">
        <mat-paginator
          [showFirstLastButtons]="true"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
  <div
    *ngIf="showBulkAdd"
    class="row center bg-white bg-default-sm u-shadow c-bulk-update">
    <div class="col u-mw--600">
      <button
        type="button"
        class="button--sm button-primary button-block"
        (click)="bulkAddLocalization()">
        <span>{{ "localization.addnewtranslations" | translate }} ({{ bulkLength }})</span>
      </button>
    </div>
  </div>
</div>
